module.exports = __webpack_public_path__ + "7df95564bd24b23aacdee2b3ddf6af9a.jpg";